import type { ProjectImage } from "@/types/portfolio"

const baseUrl = import.meta.env.VITE_IMAGES_BASE_URL?.replace(/\/$/, "")
const defaultVariant = import.meta.env.VITE_IMAGES_VARIANT || "public"

export function getImageUrl(image: ProjectImage, variant?: string): string | null {
  if (!baseUrl || !image.filename || !image.ext) return null
  const key = `${image.filename}.${image.ext}`
  const v = variant ?? defaultVariant
  return `${baseUrl}/${key}/${v}`
}
